var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: {
        id: "add-agents-dialog",
        size: "auto",
        title: "Add agents from CSV"
      },
      model: {
        value: _vm.addAgentDialog.visible,
        callback: function($$v) {
          _vm.$set(_vm.addAgentDialog, "visible", $$v)
        },
        expression: "addAgentDialog.visible"
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 mb-4" }, [
            _vm._v("\n        Import agents from csv file:\n        "),
            _c("input", {
              attrs: {
                type: "file",
                placeholder: "Import agents from csv file",
                accept: ".csv"
              },
              on: { change: _vm.readCsvFile }
            })
          ]),
          _c("div", { staticClass: "col-12" }, [
            _c("p", [
              _vm._v(
                "\n          Please provide a CSV list in the following structure:\n          "
              ),
              _c("b", [
                _vm._v(
                  "first_name,last_name,email,phone_number,market names ('|' separated):"
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("q-input", {
                staticClass: "csv-input",
                attrs: { inverted: "", type: "textarea", rows: 4 },
                on: { input: _vm.convertToJson },
                model: {
                  value: _vm.csvString,
                  callback: function($$v) {
                    _vm.csvString = $$v
                  },
                  expression: "csvString"
                }
              }),
              _vm.error
                ? _c("p", { staticClass: "text-red" }, [
                    _vm._v("\n          " + _vm._s(_vm.error) + "\n        ")
                  ])
                : _vm._e(),
              _vm.agentsData.length
                ? [
                    _c("p", [_vm._v("Agents list:")]),
                    _c(
                      "div",
                      { staticClass: "agents-list-row-wrapper row" },
                      _vm._l(_vm.agentsData, function(agent) {
                        return _c(
                          "div",
                          [
                            _c(
                              "q-tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: agent.error,
                                    expression: "agent.error"
                                  }
                                ],
                                attrs: {
                                  anchor: "top left",
                                  self: "bottom middle",
                                  offset: [-100, 0]
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(agent.error) +
                                    "\n              "
                                )
                              ]
                            ),
                            agent.added === undefined
                              ? _c("q-icon", {
                                  attrs: { name: "brightness_1", color: "gray" }
                                })
                              : agent.added
                              ? _c("q-icon", {
                                  attrs: {
                                    name: "brightness_1",
                                    color: "green"
                                  }
                                })
                              : !agent.added
                              ? _c("q-icon", {
                                  attrs: { name: "error", color: "red" }
                                })
                              : _vm._e(),
                            _c("span", [_vm._v(_vm._s(agent.email))])
                          ],
                          1
                        )
                      })
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
          _c("div", { staticClass: "row justify-content-between" }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("q-btn", {
                  attrs: { rounded: "", label: "Cancel", color: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("q-btn", {
                  attrs: {
                    disable: _vm.error !== null,
                    rounded: "",
                    label: "Add agents",
                    color: "primary"
                  },
                  on: { click: _vm.addAgents }
                })
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }